import type { EcsConfigIdTelemetry } from 'owa-analytics-types';
import { trace } from 'owa-trace';

// Match .NET String.Trim/Regex whitespace, not JavaScript's different \s set.
const SCORECARD_TOKEN =
    /^[^:\u0009-\u000D\u0020\u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]+:(?!0*[01]$)[0-9]+$/;
const TOKEN_EDGE_WHITESPACE =
    /^[\u0009-\u000D\u0020\u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]+|[\u0009-\u000D\u0020\u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]+$/g;
// Bound the whole column, never individual names/IDs.
const MAX_COMPACT_LENGTH = 32_768;

export function getEcsConfigIdTelemetry(configIds: string): EcsConfigIdTelemetry {
    const legacy = partitionEcsConfigIds(configIds);
    const tokens = legacy.EcsConfigIds.split(',')
        .map(token => token.replace(TOKEN_EDGE_WHITESPACE, ''))
        .filter(token => SCORECARD_TOKEN.test(token));
    // Preserve case: the backend uses the same ToUpperInvariant as its legacy reader.
    const compact = tokens.join(',');
    if (compact.length <= MAX_COMPACT_LENGTH) {
        return { ...legacy, EcsScorecardFlights: compact };
    }
    trace.warn(
        'Compact ECS config-state payload exceeds the limit; omitting the compact column.',
        'analytics'
    );
    return legacy;
}

export function partitionEcsConfigIds(configIds: string): EcsConfigIdTelemetry {
    const otherIds: string[] = [];
    const defaultIds: string[] = [];
    for (const entry of configIds.split(',')) {
        // Trim only for classification; preserve the original token and allocation fragment.
        const target = /^[pP]-[dD]-/.test(entry.trim()) ? defaultIds : otherIds;
        target.push(entry);
    }
    return {
        EcsConfigIds: otherIds.join(','),
        ...(defaultIds.length > 0 && { EcsDefaultConfigIds: defaultIds.join(',') }),
    };
}
